export const isValidLanguageField = (value) => {
    return value === "" || /\b(A1|A2|B1|B2|C1|C2|Native)\b/gim.test(value);
};
export const isValidEducationField = (value) => {
    const yearRegex = /\b\d\d\d\d\b/gm;
    const years = value.match(yearRegex);
    const hasEducationYear = years === null || years === void 0 ? void 0 : years.some((year) => +year > 1950 && +year < 2050);
    return !hasEducationYear;
};
export const isValidAIToolField = (name, description) => {
    const hasName = name.trim().length > 0;
    const hasDescription = description.trim().length > 0;
    return (hasName && hasDescription) || (!hasName && !hasDescription);
};
